export default __webpack_public_path__ + "static/smuin-16ccc13fce1c16059a58ad4580283dc9.jpg";